import { Button, Form, FormContent, message, Select, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import {
  apiV2AlarmRecordAnalysisGetConfigPost,
  apiV2AlarmRecordAnalysisUpsertPost,
  apiV2ComprehensiveLabelListPost,
} from '@maxtropy/device-customer-apis-v2';
import { Col, Row, Space } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MultiAreaModalSelect from './components/MultiAreaModalSelect';
import MultiRulesModalSelect from './components/MultiRulesModalSelect';
import { useRequest } from 'ahooks';
import { TabKey } from '@/pages/Circuit/LabelsManage';

const AlarmAnalysisConfig = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const monitorAreas = Form.useWatch('monitorAreas', form);
  const sceneTabs = Form.useWatch('sceneTabs', form);

  const routes = [{ name: `配置` }];

  // 查询配置
  const { data: configData } = useRequest(() => apiV2AlarmRecordAnalysisGetConfigPost());

  useEffect(() => {
    if (!configData) return;
    form.setFieldsValue({
      sceneTabs: configData.sceneTabs,
      monitorAreas: configData.monitorAreas,
      monitorAlarmRules: configData.monitorAlarmRules,
    });
  }, [configData]);

  const onFinish = (values: any) => {
    apiV2AlarmRecordAnalysisUpsertPost({ ...values }).then(_ => {
      message.success('保存成功！');
      setIsEditing(false);
    });
  };

  const { data: labelList } = useRequest(() =>
    apiV2ComprehensiveLabelListPost({ id: TabKey.DEVICE }).then(res => {
      return res.list;
    })
  );

  // options
  const labelListOptions = useMemo(() => {
    return (labelList ?? []).map(item => ({
      label: item.name,
      value: item.id,
    }));
  }, [labelList]);

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <FormContent narrow title="配置">
          <Row gutter={8}>
            <Col span={24}>
              <Form.Item name="sceneTabs" label="场景TAB选择" rules={[{ required: true, message: '请选择场景TAB' }]}>
                <Select
                  style={{ width: '100%' }}
                  placeholder="选择设备标签（最多选择5个）"
                  showSearch
                  optionFilterProp="label"
                  mode="multiple"
                  disabled={!isEditing}
                >
                  {labelListOptions.map(item => (
                    <Select.Option
                      key={item.value}
                      value={item.value}
                      disabled={(sceneTabs ?? []).length >= 5 && !(sceneTabs ?? []).includes(item.value)}
                    >
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="监测区域选择"
                name="monitorAreas"
                rules={[{ required: true, message: '请选择设备标签' }]}
              >
                <MultiAreaModalSelect isEditing={isEditing} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="持续时长监测报警规则"
                name="monitorAlarmRules"
                rules={[{ required: true, message: '请选择报警规则' }]}
              >
                <MultiRulesModalSelect isEditing={isEditing} />
              </Form.Item>
            </Col>
          </Row>

          <Space className="sticky-footer" style={{ paddingLeft: 0 }} size={8}>
            {!isEditing ? (
              <Space size={8}>
                <Button
                  type="primary"
                  onClick={() => {
                    setIsEditing(true);
                  }}
                >
                  编辑
                </Button>
                <Button onClick={() => navigate('/alarm/record/analysis')}>返回</Button>
              </Space>
            ) : (
              <Space size={8}>
                <Button
                  type="primary"
                  onClick={() => {
                    form.submit();
                  }}
                >
                  保存
                </Button>
                <Button
                  onClick={() => {
                    setIsEditing(false);
                    form.setFieldsValue({
                      sceneTabs: configData?.sceneTabs,
                      monitorAreas: configData?.monitorAreas,
                      monitorAlarmRules: configData?.monitorAlarmRules,
                    });
                  }}
                >
                  取消
                </Button>
              </Space>
            )}
          </Space>
        </FormContent>
      </Form>
    </Wrapper>
  );
};

export default AlarmAnalysisConfig;
